<div class="container">
    <div class="block">
        <img src="../../../../assets/images/email.svg" alt=""/>
        <h2>Success</h2>
        <p>Your enquiry was submitted successfully and someone will be in touch. </p>
    </div>
</div>